import React from 'react';
import Slider from 'react-slick';
import Clients from './Clients'; // Make sure this is an array of client objects with id, name, logo
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ClientSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div
      className="client-slider-section"
      style={{
        padding: '60px 0',
       
      }}
    >
      <div className="container">
        <h2 className="text-center mb-5" >
          Our Trusted Clients
        </h2>
        <Slider {...settings}>
          {Clients.map(client => (
            <div key={client.id} className="px-3">
              <div
                className="client-logo-card"
                style={{
                  background: '#fff',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '150px',
                 border: '1.5px solid #08124d'
                }}
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    transition: 'transform 0.3s ease-in-out',
                  }}
                  className="client-logo"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Add hover effects with inline or external CSS */}
      <style>{`
        .client-logo-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }
        .client-logo-card:hover .client-logo {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
};

export default ClientSlider;
